import { API_BASE_URL, MEDIA_BASE_URL } from '@/environments/environment';
import { AppEnvironment } from 'sham-components/services/core/app-environment';

export async function appEnvFactory(appEnv: AppEnvironment) {
  appEnv.BASE_URL.set(API_BASE_URL);
  appEnv.API_BASE_URL.set(`${API_BASE_URL}`);
  appEnv.MEDIA_BASE_URL.set(MEDIA_BASE_URL);
}
